export default "/packs/images/sprite~3d2af77396ea55f63be90426bc88bf33.png";